import LogService from "./LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";

const name = "SERVICE:CONFIG";

export const fetchConfigFile = () => {
    let request = new Request("/config/config.js", {
        headers: new Headers({
            "Content-Type": "application/json"
        }),
        method: "GET"
    });

    return fetch(request)
        .then(response => response.ok ? response.json() : response.json().then((error) => Promise.reject(error)))
        .then(config => {
            LogService.info(name, "initialize", "config file successfully loaded");
            return Promise.resolve(config);
        })
        .catch(error => {
            LogService.error(name, "initialize", "error when loading the config file", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}
